export const environment = {
  production: true,
  baseUrl: 'https://wiam-backend.azurewebsites.net/api',
  pubSubUrl:
    'Endpoint=https://wiam.webpubsub.azure.com;AccessKey=ZVScFphvX3Qgxuf0lIKfSosNm5NJixt+cmH3aKheCFg=;Version=1.0;',
};
